<template>
  <div
    class="rounded-lg w-full cursor-pointer border"
    :class="
      `${
        collapsed
          ? 'border-brand-gray-300'
          : 'border-brand-gray-400 border-l-brand-purple-500'
      }`
    "
  >
    <div class="flex flex-row">
      <div class="w-2 bg-brand-purple-500 rounded-l" v-if="!collapsed" />
      <div class="flex flex-col w-full py-5">
        <div
          class="w-full"
          :class="`${!collapsed ? 'pl-3 pr-5 pb-5' : 'px-5'}`"
          @click="collapsed = !collapsed"
        >
          <div class="flex flex-row justify-between font-semibold">
            <n-html :text="$t('service.account_info.question')" />
            <n-icon class="pl-6" :name="collapseIcon()" />
          </div>
        </div>
        <div v-if="!collapsed" class="border-t ml-3 mr-5 pt-5">
          <p class="typography-p-regular margin-bottom-none">
            <n-html
              v-if="activeContracts.length !== 0"
              :text="$t('service.account_info.not_allowed')"
            />
            <n-html
              v-else-if="!customer.account_deletion_requested"
              :text="$t('service.account_info.answer')"
            />
            <n-html
              v-else
              :text="$t('service.account_info.already_requested')"
            />
          </p>
          <n-button-link
            class="ml-auto"
            variant="cancel"
            :disabled="activeContracts.length > 0"
            @click.native="isDeletingInfo = true"
            ><n-html :text="$t('service.account_info.action')" />
          </n-button-link>
        </div>
      </div>
    </div>
    <modal
      v-if="isDeletingInfo"
      :title="$t('service.account_info.modal.delete_title')"
      @close="isDeletingInfo = false"
    >
      <p>
        <n-html
          v-if="hasRequestedDeletion"
          :text="$t('service.account_info.modal.requested_description')"
        />
        <n-html
          v-else
          :text="$t('service.account_info.modal.delete_warning')"
        />
      </p>
      <template v-slot:footer>
        <n-button-link bold @click.native="isDeletingInfo = false">
          <n-html
            v-if="!hasRequestedDeletion"
            :text="$t('form.common.cancel')"
          />
          <n-html v-else :text="$t('form.common.close')" />
        </n-button-link>
        <n-button-regular
          :disabled="activeContracts.length > 0"
          @click.native="deleteInfo"
        >
          <n-html :text="$t('form.common.confirm')" />
        </n-button-regular>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/theme/modal/modal";
import { mapGetters } from "vuex";
export default {
  name: "faq-card-delete",
  components: {
    Modal
  },
  data: () => ({
    collapsed: true,
    isDeletingInfo: false,
    hasRequestedDeletion: false
  }),
  computed: {
    ...mapGetters({
      customer: "customer/get",
      activeContracts: "contracts/getAllActive"
    })
  },
  methods: {
    collapseIcon() {
      return !this.collapsed ? "Chevron-up" : "Chevron-down";
    },
    deleteInfo() {
      this.$store.dispatch("user/request_customer_data_deletion").then(() => {
        this.$store.dispatch("customer/initialize");
        this.hasRequestedDeletion = true;
      });
    }
  }
};
</script>

<style scoped></style>
